import { render, staticRenderFns } from "./DamagedProducts.vue?vue&type=template&id=a22bc832&scoped=true"
import script from "./DamagedProducts.vue?vue&type=script&lang=js"
export * from "./DamagedProducts.vue?vue&type=script&lang=js"
import style0 from "./DamagedProducts.vue?vue&type=style&index=0&id=a22bc832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22bc832",
  null
  
)

export default component.exports